import { BrowserWindow } from '@wix/thunderbolt-symbols'

const getMenuContainerToggleElement = (window: BrowserWindow) => {
	if (!process.env.browser) {
		return false
	}
	return window!.document.getElementById('MENU_AS_CONTAINER_TOGGLE')
}

/**
 * Enables focus trapping in menu container if it exists on the page.
 * Use it when a custom popup or default dialog is closed.
 *
 * @param window - window global object
 */
export const enableCyclingInMenuContainer = (window: BrowserWindow) => {
	console.time('enableCyclingInMenuContainer')
	if (!process.env.browser) {
		return
	}
	const siteHeader = window!.document.getElementById('SITE_HEADER')
	const toggleBtnElement = getMenuContainerToggleElement(window)
	if (siteHeader && toggleBtnElement) {
		siteHeader.setAttribute('data-focuscycled', 'active')
		toggleBtnElement.focus()
		siteHeader.ontransitionend = () => {
			toggleBtnElement.focus()
		}
	}
	console.timeEnd('enableCyclingInMenuContainer')
}

/**
 * Disables focus trapping in menu container if it exists on the page.
 * Use it when a custom popup or default dialog is open.
 *
 * @param window - window global object
 */
export const disableCyclingInMenuContainer: (window: BrowserWindow) => void = (window: BrowserWindow) => {
	if (!process.env.browser) {
		return
	}
	const siteHeader = window!.document.getElementById('SITE_HEADER')
	if (siteHeader) {
		siteHeader.setAttribute('data-focuscycled', 'inactive')
		siteHeader.ontransitionend = null
	}
}

export const isMenuContainerToggleOnPage = (window: BrowserWindow) => {
	return !!getMenuContainerToggleElement(window)
}
